<template>
  <el-dialog
    title="添加干线保用户"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="createForm"
      :model="form"
      :rules="rules"
      label-width="100px"
      v-loading="loading"
    >
      <el-form-item label="平台名称" prop="appId">
        <el-select
          v-model="form.appId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键字搜索"
          :remote-method="getAppList"
          :loading="appLoading"
          style="width: 100%"
          @change="handleAppChange"
        >
          <el-option
            v-for="item in appOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="手机号/用户名" prop="mobile">
        <el-input
          v-model="form.mobile"
          placeholder="请输入手机号或者用户名"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="价格方案">
        <el-input
          value="东海专线保"
          disabled
        ></el-input>
      </el-form-item>
      
      <el-form-item label="渠道商" prop="channelId">
        <el-select
          v-model="form.channelId"
          filterable
          remote
          reserve-keyword
          placeholder="请先选择平台，然后输入关键字搜索渠道商"
          :remote-method="getChannelList"
          :loading="channelLoading"
          style="width: 100%"
          :disabled="!form.appId"
        >
          <el-option
            v-for="item in channelOptions"
            :key="item.id"
            :label="item.name ? `${item.name}(${item.alias})` : item.alias"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAppList, getChannelList, createDhGxbUser } from '@/api/member'

export default {
  name: 'CreateUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 手机号验证规则（可选验证）
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号或者用户名'))
      } else if (!/^1[3-9]\d{9}$/.test(value) && value.length > 11) {
        callback(new Error('请输入正确的手机号或用户名'))
      } else {
        callback()
      }
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      appLoading: false,
      channelLoading: false,
      submitting: false,
      form: {
        mobile: '',
        appId: '',
        channelId: ''
      },
      rules: {
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请选择平台名称', trigger: 'change' }
        ],
        channelId: [
          { required: true, message: '请选择渠道商', trigger: 'change' }
        ]
      },
      appOptions: [],
      channelOptions: [],
      allApps: [],
      allChannels: [],
      priceType: 3  // 东海专线保的价格方案类型
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.resetForm()
    },
    
    resetForm() {
      this.$refs.createForm.resetFields()
      this.form = {
        mobile: '',
        appId: '',
        channelId: ''
      }
    },
    
    async initData() {
      this.resetForm()
      // 初始化时加载平台列表
      await this.getAppList()
    },
    
    handleAppChange(value) {
      // 平台选择变化时，清空渠道选择
      this.form.channelId = ''
      this.channelOptions = []
      // 获取对应平台的渠道列表
      this.getChannelList()
    },
    
    async getAppList(query) {
      try {
        this.appLoading = true
        const res = await getAppList()
        if (res.err_code === 0) {
          this.allApps = res.rows || []
          
          // 处理搜索逻辑
          if (query !== undefined && query !== null && query.trim() !== '') {
            // 如果有查询关键词，进行过滤
            this.appOptions = (res.rows || []).filter(item => 
              item.name.toLowerCase().includes(query.toLowerCase())
            )
          } else {
            // 如果没有查询关键词，显示所有平台
            this.appOptions = res.rows || []
          }
        }
      } catch (error) {
        console.error('获取平台列表失败:', error)
        this.$message.error('获取平台列表失败')
      } finally {
        this.appLoading = false
      }
    },
    
    async getChannelList(query) {
      // 如果没有选择平台，不获取渠道列表
      if (!this.form.appId) {
        this.channelOptions = []
        return
      }
      
      try {
        this.channelLoading = true
        // 传递平台ID参数获取对应的渠道列表
        const params = {
          app_id: this.form.appId
        }
        const res = await getChannelList(params)
        if (res.err_code === 0) {
          this.allChannels = res.rows || []
          
          // 处理搜索逻辑
          if (query !== undefined && query !== null && query.trim() !== '') {
            // 如果有查询关键词，进行过滤
            this.channelOptions = (res.rows || []).filter(item => {
              const name = item.name || ''
              const alias = item.alias || ''
              const searchStr = name + alias
              return searchStr.toLowerCase().includes(query.toLowerCase())
            })
          } else {
            // 如果没有查询关键词，显示所有渠道
            this.channelOptions = res.rows || []
          }
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取渠道列表失败')
      } finally {
        this.channelLoading = false
      }
    },
    
    async handleSubmit() {
      this.$refs.createForm.validate(async valid => {
        if (!valid) return
        
        this.submitting = true
        try {
          const params = {
            app_id: this.form.appId,
            channel_id: this.form.channelId,
            product_alias: 'gxb-dh',  // 东海专线保产品标识
            price_type: this.priceType,  // 东海专线保的价格方案/产品类型
            type: 2  // 用户类型
          }
          
          // 如果输入的是手机号，则添加到mobile字段
          // 如果输入的是用户名，则添加到username字段
          if (/^1[3-9]\d{9}$/.test(this.form.mobile)) {
            params.mobile = this.form.mobile
          } else {
            params.username = this.form.mobile
          }
          
          const res = await createDhGxbUser(params)
          if (res.err_code === 0) {
            this.$message.success('创建成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.err_msg || '创建失败')
          }
        } catch (error) {
          console.error('创建用户失败:', error)
          this.$message.error('创建失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>